import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all projectses
export const getProjects = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/projects`);
    const data = response.data;

    if (Array.isArray(data)) {
      return { projects: data, departments: [] };
    }

    const projects = Array.isArray(data?.projects) ? data.projects : [];
    const departments = Array.isArray(data?.departments) ? data.departments : [];

    return { ...data, projects, departments };
  } catch (error) {
    console.error("Error fetching projects:", error.response?.data || error);
    throw error;
  }
};

// GET a single projects
export const getProjectsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching projects:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new projects
export const createProjects = async (projectsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/projects`, projectsData);
    return response.data;
  } catch (error) {
    console.error("Error creating projects:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing projects
export const updateProjects = async (id, projectsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/projects/${id}`, projectsData);
    return response.data;
  } catch (error) {
    console.error("Error updating projects:", error.response?.data || error);
    throw error;
  }
};

// DELETE a projects
export const deleteProjects = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting projects:", error.response?.data || error);
    throw error;
  }
};
